import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { ConfigProvider } from 'antd';
import { theme } from './theme';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/userComponents/scrollToTop';
import { HelmetProvider } from 'react-helmet-async';
import './theme/designSystem.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <HelmetProvider>
                <ConfigProvider theme={theme}>
                    <BrowserRouter>
                        <ScrollToTop />
                        <App />
                    </BrowserRouter>
                </ConfigProvider>
            </HelmetProvider>
        </Provider>
    </React.StrictMode>,
);

